<template>    
    <div class="py-4 container-fluid">        
        <div class="row">
            <div class="col-lg-12">                
                <div class="card mb-5">
                    <div class="card-header p-3 pt-2">
                        <div class="icon icon-lg icon-shape shadow text-center border-radius-xl mt-n4 position-absolute bg-gradient-success shadow-dark">
                            <i class="material-symbols-rounded opacity-10 text-white" aria-hidden="true">work_history</i>
                        </div>
                        <h6 class="mb-2" style="margin-left: 4.5rem !important;">{{ $t('sidemenu.RVO_activity_log') }}</h6>
                        <div class="row" style="margin-top: -30px">
                            <div class="col-lg-2">
                            </div>
                            <div class="col-lg-10">
                                <div class="d-flex justify-content-end align-items-center gap-2">                                    
                                    <div class="btn-group" v-if="userRoleName == 'Admin' || userRoleName == 'AssociationAdmin'" style="margin-top: 15px;">
                                        <span class="btn btn-sm bg-gradient-success text-nowrap" style="width: 150px;">
                                            {{ $t('common.Keeper') }}
                                        </span>
                                        <button type="button" class="btn btn-sm bg-gradient-success dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                                            <span class="visually-hidden">{{ $t('animal.Select_keeper') }}</span>
                                        </button>

                                        <ul class="dropdown-menu dropdown-menu-end custom-association-dropdown">
                                            <li class="px-2">
                                                <input ref="searchInput" v-model="searchQuery" type="text" class="form-control form-control-sm" :placeholder="$t('rvo.Search_Keeper')" style="display: block !important;"/>
                                                <span class="position-absolute top-50 end-0 translate-middle-y me-3 text-muted" style="cursor: pointer;" @click="clearKeeperSelection">&times;</span>
                                            </li>
                                            <li><hr class="dropdown-divider" /></li>
                                            <!-- Keepers -->
                                            <li
                                                v-for="keeper in filteredKeepers"
                                                :key="keeper.keeperRvorelationnumber"
                                                @click="selectedKeeper(
                                                    keeper.keeperRvorelationnumber,
                                                    keeper.fullName
                                                )"
                                                class="dropdown-item fs-12"
                                            >
                                                {{ keeper.keeperRvorelationnumber }} [{{ keeper.fullName }}]
                                            </li>
                                        </ul>                                        
                                    </div>
                                    <div class="btn-group" style="margin-top: 15px;">
                                        <button
                                            type="button"
                                            class="btn btn-sm bg-gradient-success text-nowrap"
                                            :class="{ disabled: !selectedKeeperRVORelationnumber  }"
                                            :disabled="!selectedKeeperRVORelationnumber"
                                            style="width: 150px;"
                                            @click="getLogData"
                                        >
                                            <span v-if="isCheckingRVOActivity">
                                                {{ $t('common.Loading') }}
                                            </span>
                                            <span v-else>
                                                {{ $t('sidemenu.Check_RVO') }}
                                            </span>
                                        </button>                                        
                                    </div>
                                </div>                                                                
                            </div>
                        </div>
                    </div>                    
                    <div class="table-responsive" ref="tableWrapper" v-show="activitylogs.length > 0"> 
                        <div class="rvo-legend mb-3">
                            <div class="rvo-legend-item">
                                <span>
                                    <strong>{{ $t('rvo.RVORelationnumber') }}:</strong>
                                    {{ loadedKeeperRVORelationnumber }}
                                    [ {{ loadedKeeperName }} ]
                                </span>
                            </div>
                        </div>
                    
                        <table id="activitylog-list" class="table table-flush" :key="activitylogKey">
                            <thead class="thead-light">
                                <tr>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('rvo.DateTime') }}</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('rvo.OperationType') }}</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('rvo.AnimalUbn') }}</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('rvo.AnimalWorkNumber') }}</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('rvo.HasFault') }}</p></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="activitylog in activitylogs"
                                    :key="activitylog.id"
                                    :data-id="activitylog.id"
                                    :class="{
                                        'rvo-has-fault': activitylog.hasFault === true,
                                        'rvo-has-nofault': activitylog.hasFault === false
                                    }"
                                >
                                        <td class="text-sm font-weight-normal align-top">{{ activitylog.dateTimeStamp }}</td>
                                        <td class="text-sm font-weight-normal align-top">{{ activitylog.operationType }}</td>
                                        <td class="text-sm font-weight-normal align-top">{{ activitylog.animalUbn }}</td>
                                        <td class="text-sm font-weight-normal align-top">
                                            <span v-html="formatAnimalWorkNumber(activitylog.animalWorkNumber)"></span>
                                        </td>
                                        <td class="text-sm font-weight-normal align-top">
                                            <i class="material-symbols-rounded opacity-10" style="font-size: 12px;" :class="activitylog.hasFault ? 'text-danger' : 'text-success'" aria-hidden="true">
                                                {{ activitylog.hasFault ? 'thumb_up' : 'thumb_down' }}
                                            </i>
                                        </td>
                                        <td class="align-top">
                                            <div class="float-end">

                                                <!-- Request XML -->
                                                 <button
                                                    :data-id="activitylog.id"
                                                    type="button"
                                                    class="mt-2 mb-0 btn btn-sm bg-gradient-success report-button"
                                                    style="margin-right: 10px !important;"
                                                    :title="$t('rvo.RequestXml')"
                                                >
                                                    <i
                                                        class="material-symbols-rounded opacity-10 text-white"
                                                        style="font-size: 0.8rem;"
                                                    >
                                                        expand_circle_down
                                                    </i>
                                                    {{ $t('rvo.RequestXml') }}
                                                </button>
                                                
                                                <!-- Response XML -->
                                                <button
                                                    :data-id="activitylog.id"
                                                    type="button"
                                                    class="mt-2 mb-0 btn btn-sm bg-gradient-success invullijst-button"
                                                    style="margin-right: 10px !important;"
                                                    :title="$t('rvo.ResponseXml')"
                                                >
                                                    <i
                                                        class="material-symbols-rounded opacity-10 text-white"
                                                        style="font-size: 0.8rem;"
                                                    >
                                                        expand_circle_down
                                                    </i>
                                                    {{ $t('rvo.ResponseXml') }}
                                                </button>

                                            </div>
                                        </td>
                                    </tr>

                                                             
                            </tbody>                            
                        </table>                
                    </div> 
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>        
</template>

<script>
import axios from 'axios';
import { nextTick } from 'vue';
import { DataTable } from "simple-datatables";

export default {
    name: 'RVO_activitylog_page',    
    components: {
    },
    data() {
        return {
            selectedKeeperName: '',
            selectedKeeperRVORelationnumber: '',

            loadedKeeperRVORelationnumber: '',
            loadedKeeperName: '',

            keeperRelationshipNumbers: [],
            activitylogs: [],

            searchQuery: '',

            gets: [],
            dataTableInstance: null,
            isCheckingRVOActivity: false,

            expandedXmlId: null,
            expandedXmlType: null,

            activitylogKey: 0
        };
    },
    computed: {
        userRoleName() {
            return this.$store.state.user?.roleName;
        },

        filteredKeepers() {
            if (!this.searchQuery) {
                return this.keeperRelationshipNumbers;
            }

            const search = this.searchQuery.toLowerCase();

            return this.keeperRelationshipNumbers.filter(keeper =>
                (keeper.fullName || '').toLowerCase().includes(search) ||
                (keeper.keeperRvorelationnumber || '').toLowerCase().includes(search)
            );
        }
    },
    async mounted() {
        try {
            this.$store.commit('setShowLoading', true);

            // Only Admin and AssociationAdmin can use this page
            if (!['Admin', 'AssociationAdmin'].includes(this.userRoleName)) {
                await this.$router.replace({ name: 'Home' });
                return;
            }

            // Load KeeperRelationship Numbers for selection
            await this.fetchAllKeeperRelationshipNumbers();
            
            this.activitylogs = [];

        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
            this.$store.commit('setShowLoading', false);
        }
    },  
    beforeUnmount() {

        this.removeXmlRow();

        if (this.$refs.tableWrapper) {
            this.$refs.tableWrapper.removeEventListener(
                'click',
                this.handleTableClick
            );
        }

        if (this.dataTableInstance) {
            try {
                this.dataTableInstance.destroy();
            } catch (error) {
                console.warn('DataTable destroy failed:', error);
            }

            this.dataTableInstance = null;
        }
    },  
    methods: { 
        removeXmlRow() {

            const existingXmlRow = document.querySelector(
                '#activitylog-list tbody tr[data-xml-row="true"]'
            );

            if (
                existingXmlRow &&
                existingXmlRow.parentNode
            ) {
                existingXmlRow.parentNode.removeChild(
                    existingXmlRow
                );
            }
        },       
        handleTableClick(event) {

            const row = event.target.closest(
                '#activitylog-list tbody tr[data-id]'
            );

            if (!row) {
                return;
            }

            const id = row.getAttribute('data-id');

            if (!id) {
                return;
            }

            const activitylog = this.activitylogs.find(
                x => String(x.id) === String(id)
            );

            if (!activitylog) {
                return;
            }

            // Request XML button
            if (event.target.closest('.report-button')) {

                this.toggleXml(activitylog, 'request');

                return;
            }

            // Response XML button
            if (event.target.closest('.invullijst-button')) {

                this.toggleXml(activitylog, 'response');

                return;
            }

            // Clicking anywhere else on the row
            // opens the request XML
            this.toggleXml(activitylog, 'request');
        },       
        async toggleXml(activitylog, type) {

            if (!activitylog) {
                return;
            }

            // Same button clicked again -> close
            if (String(this.expandedXmlId) === String(activitylog.id) && this.expandedXmlType === type) {
                this.closeXml();
                return;
            }

            // Remove currently displayed XML
            this.removeXmlRow();

            // Remember requested XML
            this.expandedXmlId = activitylog.id;
            this.expandedXmlType = type;

            // Fetch XML from server
            await this.getLogXml(activitylog.id, type);
        },
        closeXml() {
            this.expandedXmlId = null;
            this.expandedXmlType = null;

            this.removeXmlRow();
        },
        formatXml(xml) {
            if (!xml) {
                return 'No XML available.';
            }

            try {
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(xml, 'application/xml');

                // Check for invalid XML
                const parserError = xmlDoc.querySelector('parsererror');

                if (parserError) {
                    return xml;
                }

                const formatNode = (node, level = 0) => {
                    const indent = '    '.repeat(level);
                    let result = '';

                    if (node.nodeType === Node.TEXT_NODE) {
                        const text = node.nodeValue?.trim();

                        if (text) {
                            result += indent + text;
                        }

                        return result;
                    }

                    if (node.nodeType === Node.COMMENT_NODE) {
                        return `${indent}<!--${node.nodeValue}-->`;
                    }

                    if (node.nodeType !== Node.ELEMENT_NODE) {
                        return '';
                    }

                    let openingTag = `<${node.nodeName}`;

                    if (node.attributes) {
                        for (const attribute of node.attributes) {
                            openingTag += ` ${attribute.name}="${attribute.value}"`;
                        }
                    }

                    const children = Array.from(node.childNodes);

                    if (children.length === 0) {
                        return `${indent}${openingTag}/>`;
                    }

                    const hasElementChildren = children.some(
                        child => child.nodeType === Node.ELEMENT_NODE
                    );

                    // Element contains only text
                    if (!hasElementChildren) {
                        const text = children
                            .map(child => child.nodeValue || '')
                            .join('')
                            .trim();

                        return `${indent}${openingTag}>${text}</${node.nodeName}>`;
                    }

                    result += `${indent}${openingTag}>`;

                    for (const child of children) {
                        const formattedChild = formatNode(child, level + 1);

                        if (formattedChild) {
                            result += `\n${formattedChild}`;
                        }
                    }

                    result += `\n${indent}</${node.nodeName}>`;

                    return result;
                };

                return formatNode(xmlDoc.documentElement);

            } catch (error) {
                console.error('XML formatting failed:', error);
                return xml;
            }
        },
        formatAnimalWorkNumber(value) {
            if (!value) return '';

            return value
                .split(',')
                .map(x => x.trim())
                .join('<br>');
        },
        formatDate(dateStr) {
            if (!dateStr) return '';
            const d = new Date(dateStr);

            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();

            const hours = String(d.getHours()).padStart(2, '0');
            const minutes = String(d.getMinutes()).padStart(2, '0');

            return `${day}-${month}-${year} ${hours}:${minutes}`;
        },
        async initDataTable() {

            if (this.dataTableInstance) {
                return;
            }

            await nextTick();

            const table = this.$el.querySelector('#activitylog-list');

            if (!table || !table.parentNode) {
                console.warn('Activity log table is not ready.');
                return;
            }

            try {

                this.dataTableInstance = new DataTable(table, {
                    searchable: true,
                    fixedHeight: false,
                    perPageSelect: false,

                    columns: [
                        { select: 0, sortable: true },
                        { select: 1, sortable: true },
                        { select: 2, sortable: true },
                        { select: 3, sortable: true },
                        { select: 4, sortable: true },
                        { select: 5, sortable: false }
                    ],

                    labels: {
                        search: this.$t('datatable.Search'),
                        perPage: this.$t('datatable.PerPage'),
                        noRows: this.$t('datatable.NoRows'),
                        info: 'Tonen {start} t/m {end} van {rows} items',
                        placeholder: this.$t('common.Search')
                    }
                });

                if (this.$refs.tableWrapper) {
                    this.$refs.tableWrapper.addEventListener(
                        'click',
                        this.handleTableClick
                    );
                }

            } catch (error) {

                console.error(
                    'DataTable initialization failed:',
                    error
                );

                this.dataTableInstance = null;
            }
        },
        clearKeeperSelection() {
            this.selectedKeeperRVORelationnumber = '';
            this.selectedKeeperName = '';
            this.searchQuery = '';
        },
        selectedKeeper(relationNumber, fullName) {
            this.selectedKeeperRVORelationnumber = relationNumber;
            this.selectedKeeperName = fullName;
        },
        async getLogData() {

            if (!this.selectedKeeperRVORelationnumber) {
                return;
            }

            this.isCheckingRVOActivity = true;

            try {
                this.$store.commit('setShowLoading', true);

                await this.loadActivityLogs();
            }
            catch (e) {

                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`
                );
            }
            finally {
                this.isCheckingRVOActivity = false;
                this.$store.commit('setShowLoading', false);
            }
        },  
        async loadActivityLogs() {

            if (!this.selectedKeeperRVORelationnumber) {
                return;
            }

            try {

                this.$store.commit('setShowLoading', true);

                // -----------------------------------------
                // CLOSE XML
                // -----------------------------------------

                this.closeXml();

                // -----------------------------------------
                // DESTROY OLD DATATABLE
                // -----------------------------------------

                if (this.dataTableInstance) {

                    try {
                        this.dataTableInstance.destroy();
                    } catch (error) {
                        console.warn(
                            'DataTable destroy failed:',
                            error
                        );
                    }

                    this.dataTableInstance = null;
                }

                
                // -----------------------------------------
                // LOAD DATA
                // -----------------------------------------

                const response = await axios.get(
                    'RVO/getlog',
                    {
                        params: {
                            keeperRVORelationnumber:
                                this.selectedKeeperRVORelationnumber
                        }
                    }
                );

                const result = response.data;

                if (!result.success) {

                    this.$showError(
                        result.message ||
                        'Mislukt RVO berichten logboek niet verzamelen.'
                    );

                    return;
                }

                const logs = Array.isArray(result.data)
                    ? result.data.map(activitylog => ({
                        ...activitylog,
                        dateTimeStamp: this.formatDate(
                            activitylog.dateTimeStamp
                        )
                    }))
                    : [];

                // -----------------------------------------
                // SET NEW DATA
                // -----------------------------------------

                this.activitylogs = logs;

                // Update legend only after activity logs are loaded
                this.loadedKeeperRVORelationnumber =
                    this.selectedKeeperRVORelationnumber;

                this.loadedKeeperName =
                    this.selectedKeeperName;


                // Force Vue to create a completely new table
                this.activitylogKey++;

                await nextTick();

                // -----------------------------------------
                // NO DATA
                // -----------------------------------------

                if (this.activitylogs.length === 0) {

                    this.$showSuccess(
                        'errors.Success_no_animal_found'
                    );

                    return;
                }

                // -----------------------------------------
                // INITIALIZE NEW DATATABLE
                // -----------------------------------------

                await this.initDataTable();

            } catch (e) {

                console.error(
                    'loadActivityLogs error:',
                    e
                );

                this.activitylogs = [];

                const errorMessage =
                    e.response?.data?.message ||
                    e.message ||
                    this.$t('errors.Something_went_wrong');

                this.$showError(
                    `${this.$t('errors.Contact_system_admin')}: ${errorMessage}`
                );

            } finally {

                this.$store.commit(
                    'setShowLoading',
                    false
                );
            }
        },
        async getLogXml(id, type) {

            try {

                this.$store.commit('setShowLoading', true);

                const response = await axios.get(
                    'RVO/getlogxml',
                    {
                        params: { id: id }
                    }
                );

                const result = response.data;

                if (!result.success || !result.data) {
                    this.$showError(result.message || 'RVO XML could not be retrieved.');
                    return;
                }

                // Your API returns requestXml / responseXml
                const xml = type === 'request' ? result.data.requestXml : result.data.responseXml;

                if (!xml) {
                    this.$showError(type === 'request' ? this.$t('rvo.RequestXml') + ' not available.' : this.$t('rvo.ResponseXml') + ' not available.');
                    return;
                }

                const activitylog = this.activitylogs.find(
                    x => String(x.id) === String(id)
                );

                if (!activitylog) {
                    return;
                }

                // Make sure the user hasn't changed/closed
                // the requested XML while the API call was running.
                if (String(this.expandedXmlId) !== String(id) || this.expandedXmlType !== type) {
                    return;
                }

                this.insertXmlRow(activitylog, type, xml);

            } catch (e) {

                console.error('getLogXml error:', e);
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);

            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },
        insertXmlRow(activitylog, type, xml) {

            // Remove any existing XML row first
            this.removeXmlRow();

            if (!activitylog || !xml) {
                return;
            }

            // Find the actual activity row
            const mainRow = document.querySelector(`#activitylog-list tbody tr[data-id="${activitylog.id}"]`);

            if (!mainRow || !mainRow.parentNode) {
                console.warn('Activity log row not found.');
                return;
            }

            // XML ROW
            const xmlRow = document.createElement('tr');

            xmlRow.className = 'rvo-xml-row';
            xmlRow.setAttribute('data-xml-row', 'true');

            // CELL
            const cell = document.createElement('td');
            cell.colSpan = 6;
            cell.style.width = '100%';
            cell.style.maxWidth = '100%';
            cell.style.minWidth = '0';
            cell.style.padding = '0';
            cell.style.boxSizing = 'border-box';

            // XML CONTAINER
            const container = document.createElement('div');
            container.className = 'rvo-xml-container';

            // HEADER
            const header = document.createElement('div');
            header.className = 'rvo-xml-header';

            const title = document.createElement('strong');
            title.textContent = type === 'request' ? this.$t('rvo.RequestXml') : this.$t('rvo.ResponseXml');

            // CLOSE BUTTON
            const closeButton = document.createElement('button');

            closeButton.type = 'button';
            closeButton.className = 'rvo-xml-close';

            closeButton.innerHTML = '&times;';
            closeButton.title = 'Sluiten';

            closeButton.addEventListener('click', (event) => {

                event.preventDefault();
                event.stopPropagation();

                this.closeXml();
            });

            header.appendChild(title);
            header.appendChild(closeButton);

            // SCROLL CONTAINER
            const xmlScroll = document.createElement('div');
            xmlScroll.className = 'rvo-xml-scroll';

            // XML CONTENT
            const pre = document.createElement('pre');

            pre.className = 'rvo-xml-content';

            // Format and display the XML
            pre.textContent = this.formatXml(xml);

            // BUILD DOM
            xmlScroll.appendChild(pre);

            container.appendChild(header);
            container.appendChild(xmlScroll);

            cell.appendChild(container);

            xmlRow.appendChild(cell);

            // INSERT BELOW ACTIVITY ROW
            mainRow.insertAdjacentElement(
                'afterend',
                xmlRow
            );
        },
        async fetchAllKeeperRelationshipNumbers() {

            const role = this.userRoleName;            
            const associationAdminAssociationId = this.$store.state.associationAdminAssociationId;

            try {
                let response;

                if (role === 'Admin') {
                    await this.fetchAllAssociationData();
                    response = await axios.get('RVO/getkeeperrelationshipnumber');
                } else if (role === 'AssociationAdmin') {
                    this.associationId = associationAdminAssociationId;

                    response = await axios.get("RVO/getkeeperrelationshipnumber", {
                        params: {
                            associationId: this.associationId
                        }
                    });
                }
                
                const result = response.data;

                if (!result.success || !Array.isArray(result.data)) {
                    this.keeperRelationshipNumbers = [];
                    return;
                }

                this.keeperRelationshipNumbers = result.data;

            } catch (e) {                    
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }
        }       
    }
}
</script>
<style scoped>
::v-deep .choices {
    width: auto !important;
    min-width: 270px;
}

.download-link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    text-decoration: none;
}

.disabled-look {
    opacity: 0.65;
    pointer-events: none;
}

.underline-text {
    text-decoration: underline;
    text-underline-offset: 2px;
}

.fs-12 {
    font-size: 12px !important;
}

/* KEEPER DROPDOWN */
.custom-association-dropdown {
    border: 1px solid #4ca750;
}

/* SIMPLE DATATABLE */
/* DataTable top section */
::v-deep .dataTable-top {
    display: flex !important;
    justify-content: flex-start !important;
    align-items: center !important;
}

/* DataTable search */
::v-deep .dataTable-top .dataTable-search {
    margin-right: auto !important;
    width: 50% !important;
}

::v-deep .dataTable-top .dataTable-search .dataTable-input {
    width: 100% !important;
}

::v-deep .dataTable-wrapper .dataTable-top .dataTable-search input {
    border: 1px solid #d2d2d2 !important;
}

::v-deep .dataTable-top .dataTable-dropdown {
    margin-left: 10px !important;
}

/* DataTable container */
::v-deep .dataTable-container {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;

    overflow-x: hidden !important;
    overflow-y: visible !important;
}

/* DataTable wrapper */
::v-deep .dataTable-wrapper {
    width: 100% !important;
    max-width: 100% !important;
}

/* Table itself */
::v-deep #activitylog-list {
    width: 100% !important;
    max-width: 100% !important;
    margin-bottom: 0 !important;
}

/* SEARCH INPUT */
.search-txt {
    max-width: 350px;
    border: 1px solid #d2d2d2;
    font-size: 0.875rem;
    color: #495057;
    border-radius: 0.375rem;
    padding: 6px 12px;
}

.search-txt:focus {
    border: 1px solid #4ca750 !important;
    box-shadow: none !important;
    outline: none !important;
}


/* RVO ROWS */
.rvo-row-clickable {
    cursor: pointer;
}

.rvo-row-clickable:hover {
    filter: brightness(98%);
}

.rvo-has-fault {
    background-color: #f8d7da !important;
    color: #721c24 !important;
}

.rvo-has-nofault {
    background-color: #ffffff !important;
    color: #000000 !important;
}

/* TABLE ALIGNMENT */
::v-deep #activitylog-list td,
::v-deep #activitylog-list th {
    vertical-align: top !important;
}

/* RVO LEGEND */
.rvo-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    align-items: center;

    padding: 10px 15px;

    border: 1px solid #dee2e6;
    border-radius: 6px;

    background: #f8f9fa;
}

.rvo-legend-item {
    display: flex;
    align-items: center;
    gap: 8px;

    font-size: 13px;
    font-weight: 500;
}

.rvo-legend-color {
    width: 18px;
    height: 18px;

    display: inline-block;

    border-radius: 3px;
    border: 1px solid rgba(0, 0, 0, 0.15);
}

.rvo-legend-red {
    background-color: #f8d7da;
}

.rvo-legend-black {
    background-color: #ffffff;
    border: 2px solid #000;
}

/* XML EXPANDED ROW */
:deep(.rvo-xml-row) {
    width: 100% !important;
    background: #f8f9fa !important;
}

:deep(.rvo-xml-row > td) {
    width: 0 !important;
    max-width: 100% !important;
    min-width: 0 !important;

    padding: 0 !important;

    border-top: none !important;

    vertical-align: top !important;

    overflow: hidden !important;

    box-sizing: border-box;
}

/* XML CONTAINER */
:deep(.rvo-xml-container) {
    display: block;

    width: calc(100% - 30px);
    max-width: calc(100% - 30px);
    min-width: 0;

    margin: 10px 15px 15px 15px;

    box-sizing: border-box;

    border: 1px solid #d2d2d2;
    border-radius: 6px;

    background: #ffffff;

    overflow: hidden;
}

:deep(.rvo-xml-scroll::-webkit-scrollbar) {
    width: 12px;
    height: 14px;
}

:deep(.rvo-xml-scroll::-webkit-scrollbar-track) {
    background: #e9ecef;
}

:deep(.rvo-xml-scroll::-webkit-scrollbar-thumb) {
    background: #888;
    border-radius: 6px;
    border: 2px solid #e9ecef;
}

:deep(.rvo-xml-scroll::-webkit-scrollbar-thumb:hover) {
    background: #555;
}

/* XML scrolling area */
:deep(.rvo-xml-scroll) {
    display: block;

    width: 100%;
    max-width: 100%;
    min-width: 0;

    height: 450px;
    max-height: 450px;

    box-sizing: border-box;

    overflow-x: auto !important;
    overflow-y: auto !important;

    scrollbar-gutter: stable;
}


/* XML itself */
:deep(.rvo-xml-content) {
    display: block;

    width: max-content;
    min-width: 100%;
    max-width: none !important;

    margin: 0;
    padding: 15px;

    box-sizing: border-box;

    white-space: pre !important;

    word-wrap: normal !important;
    overflow-wrap: normal !important;

    font-family:
        Consolas,
        Monaco,
        "Courier New",
        monospace;

    font-size: 12px;
    line-height: 1.5;

    text-align: left;

    background: #ffffff;
    color: #212529;
}

/* XML HEADER */
:deep(.rvo-xml-header) {
    display: flex;

    align-items: center;
    justify-content: space-between;

    width: 100%;

    padding: 8px 12px;

    box-sizing: border-box;

    background: #f1f3f5;

    border-bottom: 1px solid #dee2e6;

    color: #495057;
}

:deep(.rvo-xml-header strong) {
    font-size: 13px;
    font-weight: 600;

    white-space: nowrap;
}

/* XML CLOSE BUTTON */
:deep(.rvo-xml-close) {
    width: 28px;
    height: 28px;

    padding: 0;
    margin: 0;

    display: inline-flex;

    align-items: center;
    justify-content: center;

    flex: 0 0 28px;

    border: 1px solid #adb5bd;
    border-radius: 50%;

    background: #ffffff;
    color: #6c757d;

    font-size: 18px;
    font-weight: 400;

    line-height: 1;

    cursor: pointer;

    box-sizing: border-box;

    transition:
        background-color 0.15s ease,
        border-color 0.15s ease,
        color 0.15s ease;
}

:deep(.rvo-xml-close:hover) {
    background: #dc3545;
    border-color: #dc3545;
    color: #ffffff;
}

:deep(.rvo-xml-close:focus) {
    outline: none;
    box-shadow: none;
}


/* OUTER TABLE RESPONSIVE AREA */
.table-responsive {
    width: 100%;
    max-width: 100%;
    min-width: 0;

    overflow-x: hidden !important;
    overflow-y: visible !important;
}


/* XML ROW + DATATABLE INTERACTION */
:deep(.dataTable-container) {
    min-width: 0 !important;
}

:deep(.dataTable-container table) {
    width: 100% !important;
    max-width: 100% !important;

    min-width: 0 !important;

    table-layout: fixed !important;
}


/* MOBILE */
@media (max-width: 768px) {

    ::v-deep .dataTable-top .dataTable-search {
        width: 100% !important;
    }

    :deep(.rvo-xml-container) {
        width: calc(100% - 20px);
        max-width: calc(100% - 20px);

        margin-left: 10px;
        margin-right: 10px;
    }

    :deep(.rvo-xml-content) {
        height: 350px;
        max-height: 350px;

        font-size: 11px;
    }
}
</style>